import { createAdminApi, getApiBaseUrl } from '../shared/utils';

const api = createAdminApi(`${getApiBaseUrl('layout')}/admin`, { 'x-api-version': '1.0' });

export type Revision = {
  firstSeen: string;
  hash: string;
  platformTitleId: string;
  revision: number;
  timestamp: string;
};

/**
 * Fetches a list of metadata revisions
 * @param playbackOptionId `id` field of a playbackOption, normally on the format `No=Max=12873763782`
 * @param before Only fetch revisions with timestamp earlier than this value. Alternative approach to pagination.
 */
export const fetchMetadataRevisions = (playbackOptionId: string, before?: string) =>
  api.get<Revision[]>(`raw-metadata/revisions/${playbackOptionId}`, { before });

export type MetadataRevision = {
  metadata: string;
  type: string;
};

/**
 * Fetches data from a specific revision
 * @param playbackOptionId  `id` field of a playbackOption, normally on the format `No=Max=12873763782`
 * @param hash Unique revision identifier
 * @returns API promise of detailed title containing the data from the requested revision
 */
export const fetchMetadataRevision = (playbackOptionId: string, hash: string) =>
  api.get<MetadataRevision>(`raw-metadata/content/${playbackOptionId}/${hash}`);
